/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
/* eslint-disable import/order */
import React, { Component } from 'react';
import { withMsal } from '@azure/msal-react';
import AccountCircle from '@mui/icons-material/AccountCircle';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import SecurityIcon from '@mui/icons-material/Security';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Container,
  MenuItem,
  FormControl,
  Typography,
  Select,
  CssBaseline,
  Box,
  Avatar,
  InputLabel,
  CircularProgress,
  Backdrop,
  Button,
  Stack,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { systemSelect, logUserIn, checkSecureIP } from '../../../actions';
import { loginRequest, systemIPOptions, } from '../../../config/app-config';
import { environmentVariables } from '../../../config/app-config/app-config.prd';
import i18n from "../../../helpers/i18nMain";

class SystemSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      client: environmentVariables.client,
      system: environmentVariables.system,
      clientOptions: environmentVariables.clientOptions,
      setSubmitStatus: false,
      // openBackdrop: false,
      isProceed: false
    };
  }

  handleChange = e => {
    this.setState({ client: e.target.value });
  };

  handleChangeSystem = e => {
    try {
      const system = systemIPOptions.find(s => s.label === e.target.value);
      this.setState({
        clientOptions: system.clientOtp,
        client: system.clientOtp[0].value,
        system: system.label,
      });
      this.props.systemSelect({
        systemIP: system.value,
        client: system.clientOtp[0].value,
        system: system.label,
        systemName: system.systemName,
      });
    } catch (error) {
      console.log(error);
    }
  };

  signIn = async () => {
    try {
      this.setSubmitStatus(true);
      const msalInstance = this.props.msalContext.instance;

      const response = await msalInstance.loginPopup(loginRequest);
      const { idToken } = response;

      this.props.logUserIn(this.props.enqueueSnackbar, this.setSubmitStatus, idToken);
    } catch (err) {
      console.log(err)
      this.setState({ setSubmitStatus: false });
      if (!err.toString().includes("AADB2C90091")) {
        this.props.enqueueSnackbar(
          i18n.t("authScreenTranslations:AUTHENTICATION_CANCELLED"),
          {
            variant: "error",
          }
        );
      }
    }
  };

  setSubmitStatus = value => {
    this.setState({ setSubmitStatus: value });
  };

  showProceedPopUp = () => {
    this.setState({ isProceed: true })
  }

  checkIP = () => {
    this.props.checkSecureIP(this.props.enqueueSnackbar, this.showProceedPopUp);
  }

  renderLogIn = () => {
    const { t, auth } = this.props;
    const { client, clientOptions, system, isProceed } = this.state;
    const { environment, isSecure, isSecureLoading } = auth;
    const systemText = 'Parts Dealer Portal'

    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          alignContent="center"
          sx={{ minHeight: '80vh'}}
        >
          {/* <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <AccountCircle />
          </Avatar> */}
          { isSecure === true || environment!=="PRD"  ?
            <>
              <img src="/logo.png" alt="" loading="lazy" style={{ width: 400 }} />

              <Typography textAlign="center" component="h1" variant="h5" fontWeight="bold" mt={5}>
                Parts Dealer Portal
              </Typography>
              {environment === "Development" ? (
                <>
                  <FormControl fullWidth sx={{ mb: 3, mt: 1 }}>
                    <InputLabel> {systemText}</InputLabel>
                    <Select label={systemText} value={system} onChange={this.handleChangeSystem}>
                      {systemIPOptions.map(item => (
                        <MenuItem key={item.value} value={item.label}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>{t('authScreenTranslations:CLIENT')}</InputLabel>
                    <Select
                      value={client}
                      label={t('authScreenTranslations:CLIENT')}
                      onChange={this.handleChange}
                    >
                      {clientOptions.map(item => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </>
              ) : null}

              <LoadingButton
                // loadingPosition="start"
                loading={this.state.setSubmitStatus}
                fullWidth
                variant="contained"
                sx={{ mt: 4, mb: 2 }}
                onClick={this.signIn}
              >
                {t('authScreenTranslations:SIGNIN')}
              </LoadingButton>
            </>
            :
            environment==="PRD" && <>
              <Stack flexDirection="column" alignContent="center" alignItems="center" spacing={4}>
                <img src="/logo.png" alt="" loading="lazy" style={{ width: 400 }} />

                <Typography textAlign="center" component="h1" variant="h5" fontWeight="bold" >
                  Parts Dealer Portal
                </Typography>

                <SecurityIcon color="error" sx={{
                  fontSize: 120
                }} />
                <Stack alignItems="center">
                  <Stack flexDirection="row" alignItems="center">
                    <Typography sx={{ fontSize: "small", color: "#938787", mb: 1,textAlign:"center"}}>
                      Application needs to perform system validations before allowing the device to access the portal.
                    </Typography>
                  </Stack>
                  <LoadingButton
                    // loadingPosition="start"
                    // loading={this.state.setSubmitStatus}
                    fullWidth
                    variant="contained"
                    // sx={{ mt: 4, mb: 2 }}
                    onClick={this.checkIP}
                  >
                    Check System Requirements
                  </LoadingButton>

                </Stack>

              </Stack>

              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isSecureLoading}
              // onClick={() => this.setState({ openBackdrop: true })}
              >
                <Stack flexDirection="column" alignContent="center" alignItems="center">
                  <Typography textAlign="center" sx={{ fontSize: 16 }} my={2}>
                    Please wait while we verify the system requirements.
                  </Typography>
                  <CircularProgress color="inherit" />
                </Stack>
              </Backdrop>
            </>
          }
        </Box>

        <Dialog
          open={isSecure && isProceed}
          // onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >

          <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "bold" }}>
            System Check

          </DialogTitle>
          <DialogContent>

            <Stack
              justifyContent="center" alignContent="center" alignItems="center">

              <VerifiedUserIcon color="success" sx={{
                fontSize: 150
              }} />

              <Typography textAlign="center" sx={{ fontSize: 16 }} my={2}>
                System Requirements have met, click proceed to navigate to the Portal
              </Typography>
              <Stack sx={{ width: "100%" }} flexDirection="row" justifyContent="flex-end">
                <Button variant='text' onClick={() => this.setState({ isProceed: false })}>
                  Proceed
                </Button>
              </Stack>
            </Stack>
          </DialogContent>
          {/* <DialogActions>

          <Button  autoFocus>
            Proceed To Login
          </Button>
        </DialogActions> */}
        </Dialog>
      </Container>
    );
  };

  render() {
    const { location, auth } = this.props;
    const { loggedIn } = auth;
    return loggedIn ? (
      <Redirect to={{ pathname: '/', state: { from: location } }} />
    ) : (
      this.renderLogIn()
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

const cSystemSelection = connect(mapStateToProps, {
  systemSelect,
  logUserIn,
  checkSecureIP
})(SystemSelection);
const tSystemSelection = withTranslation(['authScreenTranslations'])(cSystemSelection);
const sSystemSelection = withSnackbar(tSystemSelection);
const msSystemSelection = withMsal(sSystemSelection);

export { msSystemSelection as SystemSelection };
